module.exports = __webpack_public_path__ + "static/media/size_4_off.b0165b5a.svg";